import { useRouter } from "next/router"

export default function Register({ }) {
    const router = useRouter()

    const registerUser = async event => {
        event.preventDefault() // prevents page from redirecting on form submissiomn

        const res = await fetch("/api/register", {
            body: JSON.stringify({
                email: event.target.email.value,
                password: event.target.password.value,
                username: event.target.username.value,
                full_name: event.target.full_name.value,
            }),
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
        })

        const response = await res.json()
        console.log(response)
        if (response.error) {
            console.log(response.error)
        }
        else {
            console.log("apparent register success; redirecting")
            await router.push(`/welcome?email=${event.target.email.value}`)
        }


    }

    return (
        <form onSubmit={registerUser} className="flex flex-col items-center space-y-4">
            <div className="w-full max-w-md mx-auto">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                />
            </div>

            <div className="w-full max-w-md mx-auto">
                <label htmlFor="username" className="block text-sm font-medium text-gray-700">Username</label>
                <input
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="username"
                    required
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                />
            </div>

            <div className="w-full max-w-md mx-auto">
                <label htmlFor="full_name" className="block text-sm font-medium text-gray-700">Full Name</label>
                <input
                    id="full_name"
                    name="full_name"
                    type="text"
                    autoComplete="full_name"
                    required
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                />
            </div>

            <div className="w-full max-w-md mx-auto">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                <input
                    type="password"
                    id="password"
                    name="password"
                    required
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                />
            </div>

            <button type="submit" className="w-full max-w-md mx-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Register</button>
        </form>
    );
}